import * as actions from '../../actions/actionTypes';

const initialState = '';

export default function apiKey(state = initialState, action) {
  switch (action.type) {
    case actions.SET_API_KEY:
      if (action.body && action.body.keyString) {
        return action.body.keyString;
      } else {
        return state;
      }
    default:
      return state;
  }
}
